import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import { nextTick } from "vue";
import mitt from "mitt";

export default {
  tip(msg, type = "success", time = 2000) {
    if (!msg) {
      if (type == "error" || type == "warning") {
        msg = "请求数据失败，请稍后重试";
      }
    }

    ElMessage({
      message: msg,
      type: type,
      duration: time,
      center: true,
      "show-close": true,
    });
  },
  closeTip() {
    ElMessage.closeAll();
  },
  open(msg = "您是否确定继续操作？", title = "警告!", type = "warning") {
    return new Promise((resolve, resject) => {
      ElMessageBox.confirm(msg, title, {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          resolve("成功了");
        })
        .catch(() => {
          resject("取消了");
        });
    });
  },
  loading(isOpen = true, txt, cb) {
    let ops = {};
    ops.text = txt ? txt : "加载中";
    const loadingInstance = ElLoading.service(ops);

    if (!isOpen) {
      nextTick(() => {
        loadingInstance.close();
        cb && cb();
      });
    }
  },
  emitter: mitt(),
};
